import { effect, inject } from '@angular/core';

import { patchState, WritableStateSource } from '@ngrx/signals';

import { AUTH_ADAPTER } from '../auth-adapter.token';
import { AuthState } from './auth.store';

export const authHooksFactory = (store: WritableStateSource<AuthState>, authAdapter = inject(AUTH_ADAPTER)) => ({
  onInit() {
    effect(() => {
      const { authToken, user } = authAdapter.authState();
      patchState(store, { _authToken: authToken, _user: user });
    });
  },
});
